// import { BankAccountSummary } from '@flipdish/api-client-typescript';
import React, { useEffect } from 'react';

import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getSelectedApp, showPausedPayouts } from '../../selectors/app.selector';
import { flagService } from '../../services/flagService';
import PageLayout from '../../ui/Layout';
import Spacer from '../../ui/Spacer';
import AlertBannerBilling from '../Billing/components/AlertBannerBilling';
import { getBankAccounts } from '../Finance/Banking/banking.actions';
import { bankingSelectors } from '../Finance/Banking/banking.selectors';
import AlertBankVerification from './Configs/AlertBankVerification';
import SetupConfigList from './Configs/List';
import Savings from './Savings/Savings';
import { getWelcomeTitle } from './selectors';
import StoreCardList from './Stores/List';

type InnerProps = MappedState & MappedDispatch;
type Props = ReturnType<typeof mapStateToProps> & InnerProps;

const Home = (props: Props) => {
  const {
    bankAccountAlerts,
    currentApp,
    isAlertBannerInvoiceOn,
    loadSetup,
    showPausedPayouts = false,
    title,
  } = props;
  const isFlipdishGlobal = currentApp.AppId === 'flipdish-global';

  useEffect(() => loadSetup(), []);

  return (
    <PageLayout title={title}>
      <Grid container>
        {!isFlipdishGlobal &&
          bankAccountAlerts.map((acc) => (
            <Grid item xs={12} key={acc.priority}>
              <AlertBankVerification account={acc} />
            </Grid>
          ))}
        {!isFlipdishGlobal && isAlertBannerInvoiceOn && !showPausedPayouts && (
          <AlertBannerBilling />
        )}

        <Grid item xs={12}>
          <Savings />
        </Grid>

        <Grid item xs={12}>
          <SetupConfigList />
          <Spacer size={24} />
        </Grid>

        <Grid item xs={12}>
          <StoreCardList />
        </Grid>
      </Grid>
    </PageLayout>
  );
};

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => {
  return {
    title: getWelcomeTitle(state),
    currentApp: getSelectedApp(state),
    bankAccountAlerts: bankingSelectors.getBankAccountAlerts(state),
    isAlertBannerInvoiceOn: flagService.isFlagOn(state, 'alertBannerInvoice'),
    showPausedPayouts: showPausedPayouts(state),
  };
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  loadSetup: () => {
    dispatch(getBankAccounts());
  },
});

export default compose<InnerProps, {}>(connect(mapStateToProps, mapDispatchToProps))(Home);
